import { AxDropdown } from "@axess/limestone";
import Swal from "sweetalert2";
import { AxLoad } from "../../../../Lib/AxSystem/AxLoad";
import { AxCounter } from "../../../../Limestone/AxCounter/AxCounter";
import { AxLoading } from "../../../../Limestone/AxLoading/AxLoading";
import { RentalItemIdentifier } from "../../../../Models/Rental/Details/RentalItemIdentifier";
import { RentalProdSelectionTimings } from "../../../../Models/Rental/Details/RentalProdSelectionTimings";
import { RentalProductDetails } from "../RentalProductDetails";
import { RentDetailsProdSelectionAbstract } from "./RentDetailsProdSelectionAbstract";
import { RentDetailsProdSelectPackHandler } from "./RentDetailsProdSelectPackHandler";
import { RentDetailsProdSelectSingleItemHandler } from "./RentDetailsProdSelectSingleItemHandler";
import { ForeignCurrencyConfig, ForeignCurrencyPriceHelper } from "../../../../Lib/Helper/ForeignCurrencyPriceHelper";

export class RentDetailsProdSelectCompManager {
    private rentalSelectionItem: RentalItemIdentifier;
    private axLoading = new AxLoading();
    private locationDropDown = new AxDropdown();
    private rentalDetailProdSelection: RentDetailsProdSelectionAbstract;
    private foreignCurrencyHelper: ForeignCurrencyPriceHelper;

    productCounters: AxCounter[] = [];

    constructor(rentalSelectionItem: RentalItemIdentifier, foreignCurrencyConfig?: ForeignCurrencyConfig) {
        this.rentalSelectionItem = rentalSelectionItem;
        this.foreignCurrencyHelper = foreignCurrencyConfig
            ? new ForeignCurrencyPriceHelper(foreignCurrencyConfig)
            : null;
    }

    getProdSelectionComponent(): RentDetailsProdSelectionAbstract {
        return this.rentalDetailProdSelection;
    }

    locationIsSet(): boolean {
        return this.rentalDetailProdSelection?.getSelectedLocationId() !== undefined;
    }

    quantityOk(): boolean {
        return this.rentalDetailProdSelection?.getAllProductsCount() > 0;
    }

    loadRentDetailsProdSelectComponent(prodSelectionTimings: RentalProdSelectionTimings) {

        if (!prodSelectionTimings.allBookingTimeParametersAreSet()) {
            return;
        }

        const data = {
            productTripleWithType: {
                projNr: this.rentalSelectionItem.projNr,
                productGroupIdentifier: this.rentalSelectionItem.productGroupIdentifier,
                id: this.rentalSelectionItem.id,
                // Rental = 4 todo: enum or constant
                // Package = 1
                // RentalSelectionItemType: 1 == SingleItem
                Type: this.rentalSelectionItem.rentalSelectionItemType === 0 ? 4 : 1
            },
            startSoapDate: prodSelectionTimings.startSoapDate,
            durationIdentifier: prodSelectionTimings.durationIdentifier,
            pickUpTimeId: prodSelectionTimings.pickUpTimeId
        };

        const url = this.getCorrectLinkForPartial();

        $('.rental_detail__selection-area-holder').addClass('position-relative ');
        $('.rental_detail__selection-area-holder').html('<div style="min-height: 250px;"></div>');

        this.axLoading.ShowLoadingIndicator($('.rental_detail__selection-area-holder')[0], true);

        AxessViewer.loadPartialView(url, data, (res) => {

            if (!res.success) {
                Swal.fire("Error", res.errorMessage);
                this.axLoading.HideLoadingIndicator($('.rental_detail__selection-area-holder')[0]);
                const rentalProductDetailsModule = AxLoad.GetModule<RentalProductDetails>('RentalProductDetails');
                rentalProductDetailsModule.disableProceedBtn();
                return;
            }

            let returnView = res.returnView;

            $('.rental_detail__selection-area-holder').html(returnView);

            this.initPartialEventsAfterLoad(prodSelectionTimings, res);
            this.initLocationDropDown(res.preSelectedLocation);

            let retailsAlertBannerData = new DetailsAlertBannersData(res.rentalDetailsAlertBannersViewModel.alertBannerText,
                res.rentalDetailsAlertBannersViewModel.arcAlertBannerHeaderText, res.rentalDetailsAlertBannersViewModel.arcAlertMessages,
                res.rentalDetailsAlertBannersViewModel.pickupTimeAtAllArcsValid)

            this.showBookingPeriodAlert(retailsAlertBannerData.alertBannerText);

            if (retailsAlertBannerData.pickupTimeAtAllArcsValid === false) {
                this.showArcAvailabilityAlert(retailsAlertBannerData);
            }
            this.axLoading.HideLoadingIndicator($('.rental_detail__selection-area-holder')[0]);
        }, {
            //dataType: 'html'
        });
    }

    private showBookingPeriodAlert(alertBannerText: string) {
        let alertElement = document.getElementById('bookingPeriodAlert');
        alertElement.innerHTML = alertBannerText;
        alertElement.removeAttribute("hidden");
    }

    private showArcAvailabilityAlert(rentalDetailsAlertBannerData: DetailsAlertBannersData) {
        const alertMsgHolderDiv = document.createElement('div');

        const headerParagraph = document.createElement('p');
        headerParagraph.textContent = rentalDetailsAlertBannerData.arcAlertBannerHeaderText;
        headerParagraph.classList.add('font-weight-bold');

        alertMsgHolderDiv.appendChild(headerParagraph);

        rentalDetailsAlertBannerData.arcAlertMessages.forEach((alertMesg, index) => {
            const paragraph = document.createElement('p');
            paragraph.textContent = alertMesg;
            alertMsgHolderDiv.appendChild(paragraph);
        });

        let alertElement = document.getElementsByClassName('arcAvailabilityAlert');
        alertElement[0].innerHTML = alertMsgHolderDiv.outerHTML;
        alertElement[0].removeAttribute("hidden");
    }

    private initPartialEventsAfterLoad(prodSelectionTimings: RentalProdSelectionTimings, result: any) {
        switch (this.rentalSelectionItem.rentalSelectionItemType) {
            case 0:
                this.initSingleEventsAfterLoad(prodSelectionTimings, result.pricesPerPersonType);
                break;
            case 1:
                this.initPackageEventsAfterLoad(prodSelectionTimings, result.packageList);
                break;
            case 2:
                this.initPackageEventsAfterLoad(prodSelectionTimings, result.packageList);
                break;
        }
    }

    private initSingleEventsAfterLoad(prodSelectionTimings: RentalProdSelectionTimings, pricesPerPersonType: any) {
        this.rentalDetailProdSelection = new RentDetailsProdSelectSingleItemHandler(prodSelectionTimings, pricesPerPersonType, this.foreignCurrencyHelper);
    }

    private initPackageEventsAfterLoad(prodSelectionTimings: RentalProdSelectionTimings, packageList: any) {
        this.rentalDetailProdSelection = new RentDetailsProdSelectPackHandler(prodSelectionTimings, packageList, this.foreignCurrencyHelper);
    }

    private getCorrectLinkForPartial(): string {
        let url = '';

        switch (this.rentalSelectionItem.rentalSelectionItemType) {
            case 0:
                url = '/RentalDetails/LoadSingleItemDetailsSelectionPartial';
                break;
            case 1:
                url = '/RentalDetails/LoadPackageItemDetailsSelectionPartial';
                break;
            case 2:
                url = '/RentalDetails/LoadPackageGroupItemDetailsSelectionPartial';
                break;
        }

        return url;
    }

    private initLocationDropDown(preSelectedLocation) {
        this.locationDropDown.init(`.rental_details__location`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: (elem: any) => { this.onSelectLocationDropDown(elem) }
            });

        if (preSelectedLocation) {
            this.locationDropDown.setValue(preSelectedLocation);
        }
    }

    private onSelectLocationDropDown(elem: any) {
        const arcNr = parseInt(this.locationDropDown.getValue().toString());
        this.rentalDetailProdSelection?.setLocationId(arcNr);
        const rentalProductDetailsModule = AxLoad.GetModule<RentalProductDetails>('RentalProductDetails');

        $('.rental_details__locationLink').addClass('d-none');
        $(`.rental_details__locationLink[data-target="${arcNr}"]`).removeClass('d-none');

        rentalProductDetailsModule.refreshProceedBtn();
    }
}

class DetailsAlertBannersData {
    constructor(alertBannerText: string, arcAlertBannerHeaderText: string, arcAlertMessages: string[], pickupTimeAtAllArcsValid: boolean) {
        this.alertBannerText = alertBannerText;
        this.arcAlertBannerHeaderText = arcAlertBannerHeaderText;
        this.arcAlertMessages = arcAlertMessages;
        this.pickupTimeAtAllArcsValid = pickupTimeAtAllArcsValid;
    }

    public alertBannerText: string;
    public arcAlertBannerHeaderText: string;
    public arcAlertMessages: string[];
    public pickupTimeAtAllArcsValid: boolean;
}